// client/src/apiConfigClient.js
// Determine API base URL
const CLIENT_URL =
  process.env.NODE_ENV === "production"
    ? process.env.CLIENT_PROD
    : process.env.CLIENT_DEV;

export default CLIENT_URL;
